module.exports = "./img/2602b990f21dd5c05e7d18e796421b35.jpg";